<script setup>
import { ref } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  title: { type: String, required: true },
  defaultOpen: { type: Boolean, default: true },
});

const open = ref(props.defaultOpen);
</script>

<template>
  <section class="flex flex-col border-b border-n-weak last:border-b-0">
    <button
      type="button"
      class="flex items-center justify-between w-full px-3 py-2.5 text-start hover:bg-n-alpha-1"
      :aria-expanded="open"
      @click="open = !open"
    >
      <span
        class="text-[11px] font-semibold tracking-wide uppercase text-n-slate-11"
      >
        {{ title }}
      </span>
      <Icon
        icon="i-lucide-chevron-down"
        class="size-3.5 transition-transform text-n-slate-10"
        :class="{ '-rotate-90 rtl:rotate-90': !open }"
      />
    </button>
    <div v-if="open" class="flex flex-col gap-4 px-3 pb-4">
      <slot />
    </div>
  </section>
</template>
